import type { HTMLAttributes } from 'react'

export type TextSizes =
  | 'xxs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'xxl'
  | 'xxxl'
  | 'xxxxl'
  | 'xxxxxl'

export type TextColors =
  | 'text'
  | 'text1'
  | 'text2'
  | 'text3'
  | 'text4'
  | 'text5' // same as text
  | 'eggplant'
  | 'title'

export type TextProps = HTMLAttributes<HTMLElement> & {
  align?: 'center' | 'left' | 'right'
  as?:
    | 'span'
    | 'p'
    | 'li'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'dd'
    | 'dt'
  wrap?: 'pretty' | 'balance'
  fontSize?: TextSizes
  lineHeight?: number | string
  color?: TextColors
  fontWeight?: 300 | 400 | 500 | 600 | 700 | 800 | 900
  /** Font sizes will step down 1 size on small screens */
  responsive?: boolean
}

type HeadingLevels = 1 | 2 | 3 | 4 | 5 | 6

/**
 * Line heights should probably get prescriptive. This is a punt.
 */
export const H1_LINE_HEIGHT = 1.3

export type NarrowText = Omit<TextProps, 'as'>

export type HeadingProps = NarrowText & {
  /**
   * @default 3
   */
  level?: HeadingLevels
}
